import type { OAISchema } from '~/types/openapi';

/**
 *
 * 깊은 depth에 있는 상품 정보들을 flatten화
 *
 */

export const flatVendorGroupsShoppingCartItem = (
  vendorGroups: OAISchema['MarketShoppingCartVendorGroupResponse'][],
) => {
  const flattenList = vendorGroups
    .map((group) =>
      group.shoppingCartItemBundles
        .map(({ shoppingCartItems }) => shoppingCartItems)
        .flat(),
    )
    .flat();

  return flattenList;
};

export const parseInvalidStatus = (
  status: OAISchema['MarketShoppingCartItemResponseV2']['status'],
) => {
  switch (status) {
    case 'UNDELIVERABLE':
      return '현재 배송이 불가능한 지역입니다.';
    case 'NORMAL':
    case 'OUT_OF_STOCK':
    case 'DISCONTINUED':
    case 'INDIVIDUAL_QUANTITY_LIMIT_EXCEEDED':
    case 'UNSATISFIED_MINIMUM_ORDER_QUANTITY':
    case 'UNSATISFIED_ORDERABLE_QUANTITY':
    case 'LESS_QUANTITY_THAN_ITEM_QUANTITY':
    case 'ALREADY_ORDERED_FIRST_ORDER_PRODUCT':
      return '현재 구매 불가능한 상품입니다.';
    default:
      return '현재 구매 불가능한 상품입니다.';
  }
};
